import { TextArea } from '../../../atoms/Textarea';
import { Button } from '../../../atoms/Button';
import { Modal } from '../../../templates/Modal';
import { useReportContent } from '../../../../hooks/useReportContent';
import { useEffect, useState } from 'react';
import { toast } from '../../../atoms/Toast';
import { useContentActionsContext } from '../../../../hooks/Contexts/useContentActionsContext';

interface IContentReportModal {
  isOpen: boolean;
  onClose: () => void;
}

export function ContentReportModal({ isOpen, onClose }: IContentReportModal) {
  const [reportMessage, setReportMessage] = useState<string>();
  const { contentId, contentType } = useContentActionsContext();
  const { isLoading, mutateAsync: reportContent } = useReportContent();

  async function handleReportContent() {
    if (!contentId || !contentType) {
      toast({
        variant: 'warning',
        message:
          'Não foi possível identificar o conteúdo, por favor, tente novamente',
      });
      return;
    }

    if (!reportMessage) {
      toast({
        variant: 'warning',
        message:
          'Por favor, descreva o problema que você encontrou no conteúdo',
      });
      return;
    }

    try {
      await reportContent({
        contentId: contentId,
        message: reportMessage,
        type: contentType,
      });

      onClose();

      toast({
        variant: 'success',
        message: 'Problema relatado com sucesso!',
      });
    } catch (error) {
      toast({
        variant: 'error',
        message:
          'Não foi possível relatar o problema, tente novamente mais tarde.',
      });
    }
  }

  useEffect(() => {
    if (!isOpen) {
      setReportMessage('');
    }
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={'Relatar problema no conteúdo'}
      size='md'
      noPadding
      className=''
    >
      <div className=' p-4'>
        <TextArea
          label='Descreva o que você encontrou de errado neste conteúdo'
          required
          maxLength={255}
          value={reportMessage}
          onChange={(e) => setReportMessage(e.target.value)}
          rows={4}
        />
      </div>
      <div className='flex gap-lg border-t-thin border-t-mono-color-lightest px-4 py-5 shadow-level-2'>
        <Button variant='outlined' onClick={onClose} full>
          Cancelar
        </Button>
        <Button
          variant='contained'
          onClick={handleReportContent}
          loading={isLoading}
          full
        >
          Relatar problema
        </Button>
      </div>
    </Modal>
  );
}
